'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.mountPanels = mountPanels;
exports.mountContent = mountContent;
exports.mountImage = mountImage;
exports.mountBG = mountBG;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TextBlock = require('./blocks/TextBlock');

var _TextBlock2 = _interopRequireDefault(_TextBlock);

var _Button = require('./blocks/Button');

var _Button2 = _interopRequireDefault(_Button);

var _slsZoneCdnHelper = require('sls-zone-cdn-helper');

var _slsZoneCdnHelper2 = _interopRequireDefault(_slsZoneCdnHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PRESET_WIDTH_HEIGHT = [80, 100, 200, 400, 600, 800, 1200, 1400];

function mountPanels(mountText, mountActions) {
  return _react2.default.createElement(
    'div',
    { className: 'wsequiz_panel_container' },
    _react2.default.createElement(
      'div',
      { className: 'wsequiz_text_panel' },
      mountText()
    ),
    _react2.default.createElement(
      'div',
      { className: 'wsequiz_action_panel' },
      mountActions()
    )
  );
}

function mountContent(data, handleNext, previewQuizScreen, preview, trackEvent) {
  var texts = data.get('texts');
  var buttons = data.get('buttons');
  return _react2.default.createElement(
    'div',
    { className: 'wsequiz_content' + (preview ? ' preview' : '') },
    texts && texts.map(function (text) {
      return _react2.default.createElement(_TextBlock2.default, { key: text.get('id'), data: text });
    }),
    buttons && buttons.map(function (button) {
      return _react2.default.createElement(_Button2.default, {
        key: button.get('id'),
        data: button,
        handleNext: handleNext,
        previewQuizScreen: previewQuizScreen,
        trackEvent: trackEvent
      });
    })
  );
}

function mountImage(image, params) {
  var _ref = params || {},
      width = _ref.width,
      height = _ref.height;

  var imgSize = calTypeByContainerSize({ width: width, height: height });
  var imgParams = {
    width: imgSize.width
  };
  return _react2.default.createElement('img', { src: (0, _slsZoneCdnHelper2.default)(image.toJS(), imgParams) });
}

function mountBG(props, children) {
  var width = props.width,
      height = props.height,
      image = props.image,
      scale = props.scale,
      restProps = _objectWithoutProperties(props, ['width', 'height', 'image', 'scale']);

  var imgSize = calTypeByContainerSize({ width: width, height: height, scale: scale });
  var imgParams = {
    width: imgSize.width
  };

  var style = {
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat'
  };
  if (image) {
    style.backgroundImage = 'url(' + (0, _slsZoneCdnHelper2.default)(image.toJS(), imgParams) + ')';
  }

  return _react2.default.createElement(
    'div',
    _extends({}, restProps, { style: style }),
    children
  );
}

function calTypeByContainerSize(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      _ref2$scale = _ref2.scale,
      scale = _ref2$scale === undefined ? 1 : _ref2$scale;

  var ratio = Math.round(1000 * width / height) / 1000;
  var w = width * scale;
  return {
    width: PRESET_WIDTH_HEIGHT.reduce(function (prev, cur) {
      return Math.abs(prev - w) <= Math.abs(cur - w) ? prev : cur;
    }, 0),
    height: Math.floor(width * ratio),
    ratio: ratio,
    isLandscape: ratio > 1
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/wse-quiz-component/lib/RenderHelper.js
// module id = 96
// module chunks = 0